import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const Contact = () => {
  const { t } = useTranslation();


  return (
    <React.Fragment>
      <div className='content-box innrpages'>
        <div className='innerContainer'>
          <p>{t('contact.title')}</p>
          <p>{t('contact.subtitle')} <Link to="mailto:hello@resay.org">hello@resay.org</Link></p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Contact;
